import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';


class SearchContent extends Component {
  constructor(props){
    super(props);

    this.state = {
      searchTerm: '',
      searchProduct: '',
      count: 0,
      results: []
    }

    this.getContent = this.getContent.bind(this).bind(this);
    this.parseBlockResults = this.parseBlockResults.bind(this);
 }

  componentDidMount() {
    this.getContent();
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps){return;}
    this.props = newProps;
    this.getContent();
  }

  parseBlockResults(textBlockArray){

    // check that a value exists and it is of type array
    // if not, return it without processing
    if(!textBlockArray) return <i>Search matched to title only</i>;
    if(!Array.isArray(textBlockArray)) { return textBlockArray; } 

    return textBlockArray.filter((block, idx) => {
      if(idx < 3) {
        return <p>{block}</p> //cap at three
      }
    });
  }

  getContent(){
    const searchPath = this.props.location.pathname;
    const apiUrl = `${window.location.protocol}//${window.location.host}/api${searchPath}`;

    fetch(apiUrl)
    .then(res => res.json())
    .then(data => {
      const search = data.search;
      const results = data.results;

      //set state with new values
      this.setState({ 
        searchTerm: search.term,
        searchProduct: search.product, 
        count: results.length, 
        results: results });
    });
  }

  setResults(results){
    
    if(!results || results.length === 0){
      return (
        <div className="search-result">
          <p>No results found for your search.</p>
        </div>
      )
    }

    return results.map(r => {
      let docParams = r.document.key.split(':');
      const docPath = docParams.join('/');
      const convScore = parseFloat(r.score * 100).toFixed(0);

      return (
        <div className="search-result">
          <h2><NavLink 
                to={`/${docPath}`}>
                {r.document.title}
              </NavLink></h2>
          <p>{this.parseBlockResults(r.snippits[0].textBlockArray)}...</p>
          <div className="relevance">Relevance: {(convScore > 100) ? 100 : convScore}&#37;</div>
        </div>
      );
    });
  }

  render(){
    return (
      <div>
        <h1>Search Results</h1>
        <h3 className="result-count">Showing { this.state.count } result(s) matching <strong>'{this.state.searchTerm}'</strong></h3>
        { this.setResults(this.state.results) }
      </div>
    );
  }
}

export default SearchContent;
